export default __webpack_public_path__ + "static/media/kumbang_logo.6fc68312.png";